"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ========== ~~~~~~~~~~ EXPORT : TAB ~~~~~~~~~~ ========== */

var _default = function _default(props) {
  // dummy function used by purely as a way to iterate over number of "tab" components and created PROPER structure in tabs component
  return null;
};

exports.default = _default;